import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TokenService } from '../../services/token.service';

import { TranslatePipe } from '@ngx-translate/core';
import { UsersService } from '../../services/users.service';
import { AvatarModule } from 'primeng/avatar';
import { InitialsPipe } from '../../_pipes/initials.pipe';
import { User, UserAdapter } from '../../models/user';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslatePipe, AvatarModule, InitialsPipe, NgTemplateOutlet],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})


export class SidebarComponent implements OnInit {

  currentUser!: User;

  constructor(
    public tokenService: TokenService,
    private usersService: UsersService,
    private userAdapter: UserAdapter
  ) {}

  ngOnInit() {
    this.usersService.getCurrentUser().subscribe({
      next: (userData) => {
        this.currentUser = this.userAdapter.adapt(userData); 
      },
      error: (error) => {
        console.error('Error fetching current user in sidebar:', error);
      },
      complete: () => {
      }
    });
  }

  logout():void{
    this.tokenService.clearToken();
  }

  isLogged(): boolean {
    return this.tokenService.isLogged();
  }
}


